/**
 * @module-isolated analytics-lab
 * Comparación de definiciones GI Analytics vs LeadTrack (auditoría 2026-08-06).
 * Solo documentación — no calcula métricas.
 */
export const DEFINITION_ROWS = [
  {
    metric: 'Leads del embudo',
    gi: 'Espejo Kommo (sync) + reglas Sales Analytics / etapas internas GI.',
    leadtrack: 'Cuenta Kommo sync + subconjunto “llegaron a Lead Tracker” (tracker propio).',
    same: false,
    note: 'En la auditoría: 263 Kommo vs 6 en LT. No son el mismo universo.'
  },
  {
    metric: 'Leads sin contacto / SLA',
    gi: 'Sales Analytics: aging, SLA primer contacto, cola de atención.',
    leadtrack: '“Necesita tu atención” (ej. leads sin contactar con días).',
    same: false,
    note: 'Idea UX similar; umbrales y fuente pueden diferir.'
  },
  {
    metric: 'Reuniones del período',
    gi: 'Sheet Reuniones (ops): agendadas, canceladas, ya pasaron, minuta.',
    leadtrack: 'Calendario Google sync + match a lead; realizadas / pendientes / no asistió.',
    same: false,
    note: 'LT alerta reuniones sin lead; GI no tiene ese join como KPI principal.'
  },
  {
    metric: 'Tasa de asistencia',
    gi: 'No disponible (sin campo asistencia / no-show canónico).',
    leadtrack: 'KPI central desde tracker + kanban (asistió / no).',
    same: false,
    note: 'Brecha de captura en GI, no de UI.'
  },
  {
    metric: 'Tasa de agendamiento',
    gi: 'Parcial vía Comercial/Reuniones; no mismo denominador que LT.',
    leadtrack: 'Leads con reunión / leads del embudo Kommo en LT.',
    same: false,
    note: 'Denominador distinto → % distintos aunque ambos “agendamiento”.'
  },
  {
    metric: 'Inversión / CPL Meta',
    gi: 'Marketing API Meta (vivo) en módulo Marketing.',
    leadtrack: 'Slot Meta Ads por portafolio (en workspace auditado: no conectado).',
    same: false,
    note: 'GI hoy mide Meta más profundo que LT en esa cuenta.'
  },
  {
    metric: 'Reservas',
    gi: 'Sheet Reservas (estados, montos, por proyecto/ejecutivo).',
    leadtrack: 'Flag “Reserva” en tracker de leads (✓/✗ inline).',
    same: false,
    note: 'Operación diaria (LT) vs analitica de sheet (GI).'
  },
  {
    metric: 'Cierre / venta / $',
    gi: 'Venta y comisión: no disponible hasta definición + fuente.',
    leadtrack: 'Flags Compró + $ Vendido en tracker.',
    same: false,
    note: 'LT captura operativo; GI aún no declara venta canónica.'
  },
  {
    metric: 'Flujo Inversión → Retorno',
    gi: 'Resumen ejecutivo (nodos con real / N/D).',
    leadtrack: 'No es narrativa económica completa; foco reunión/cierre.',
    same: false,
    note: 'Productos distintos: centro de control vs CRM de reuniones.'
  },
  {
    metric: 'Metas mensuales',
    gi: 'Especificadas; store aún no (Lab Metas = borrador local).',
    leadtrack: 'Settings: metas + semáforo.',
    same: false,
    note: 'Lab Metas no alimenta KPIs oficiales.'
  }
];
